import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import enTranslations from './locales/en/translation.json'
import fiTranslations from './locales/fi/translation.json'

const resources = {
  en: { translation: enTranslations },
  fi: { translation: fiTranslations },
}

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    debug: false,
    supportedLngs: ['fi', 'en'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly', // normalize en-US -> en
    lowerCaseLng: true, // normalize EN -> en
    cleanCode: true, // general code cleanup
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  })

export default i18next
